var exports = {
  "Qs": "CustomStatusDisplay.module__content___aEZtaH",
  "pF": "CustomStatusDisplay.module__singleLine___aEZtaH",
  "tD": "CustomStatusDisplay.module__constrained___aEZtaH",
  "IY": "CustomStatusDisplay.module__truncatedText___aEZtaH",
  "j9": "CustomStatusDisplay.module__clamped___aEZtaH",
  "H0": "CustomStatusDisplay.module__statusEmoji___aEZtaH",
  "My": "CustomStatusDisplay.module__statusEmojiWrapper___aEZtaH",
  "hb": "CustomStatusDisplay.module__staticEmoji___aEZtaH",
  "oG": "CustomStatusDisplay.module__animatedEmoji___aEZtaH",
  "kK": "CustomStatusDisplay.module__hiddenVisually___aEZtaH",
  "SA": "CustomStatusDisplay.module__jumbo___aEZtaH",
  "We": "CustomStatusDisplay.module__editableWrapper___aEZtaH",
  "Ke": "CustomStatusDisplay.module__editableTextHover___aEZtaH",
  "BW": "CustomStatusDisplay.module__editPencilIcon___aEZtaH",
  "dX": "CustomStatusDisplay.module__editableEmojiOnly___aEZtaH",
  "qf": "CustomStatusDisplay.module__placeholder___aEZtaH",
  "Dm": "CustomStatusDisplay.module__placeholderIcon___aEZtaH",
  "RC": "CustomStatusDisplay.module__placeholderText___aEZtaH",
  "_C": "CustomStatusDisplay.module__emojiPressable___aEZtaH",
  "on": "CustomStatusDisplay.module__emojiTooltipTrigger___aEZtaH",
};

module.exports = exports;
